// Test IDs for the Autonomous Growth Team (Orchestrator + 5 specialist agents) feature.

export const GROWTH_TEAM = {
  navLink: 'home-nav-growth-team-link',
  specialistCard: (key) => `growth-team-specialist-card-${key}`,
  appLink: (id) => `growth-team-app-link-${id}`,
  loading: 'growth-team-loading',
  message: (i) => `growth-team-message-${i}`,
  input: 'growth-team-input',
  sendBtn: 'growth-team-send-btn',
  error: 'growth-team-error-message',
  resetBtn: 'growth-team-reset-btn',
  resetCancelBtn: 'growth-team-reset-cancel-btn',
  resetConfirmBtn: 'growth-team-reset-confirm-btn',
  weeklyBriefBtn: 'growth-team-weekly-brief-btn',
  handoffBtn: (i) => `growth-team-handoff-video-btn-${i}`,
  saveAsoBtn: (i) => `growth-team-save-aso-btn-${i}`,
  saveSequenceBtn: (i) => `growth-team-save-sequence-btn-${i}`,
};
